import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Redirect } from 'react-router';
import Admin from "./components/pages/admin/Admin";
import Results from "./components/pages/insurance/property/quoting/Results";
import QuotingConfirm from "./components/pages/insurance/property/quoting/QuotingConfirm";
import ThankYou from "./components/pages/insurance/property/ThankYou";
import Reports from "./components/pages/admin/Reports";
import Login from "./components/auth/Login";
import PrivateRoute from "./components/auth/PrivateRoute";
import Renewals from "./components/pages/admin/Renewals";
import Claims from "./components/pages/admin/Claims";
import EditClaim from "./components/pages/admin/EditClaim";
import Policies from "./components/pages/admin/Policies";
import Quotes from "./components/pages/admin/Quotes";
import QuotingForm from "./components/pages/insurance/property/quoting/QuotingForm";
import RenewalsForm from "./components/pages/insurance/property/renewals/RenewalsForm";
import RenewalsConfirm from "./components/pages/insurance/property/renewals/RenewalsConfirm";
import MtaForm from "./components/pages/insurance/property/mtas/MtaForm";
import MtaConfirm from "./components/pages/insurance/property/mtas/MtaConfirm";
import Rates from "./components/pages/admin/Rates";
import ValidateRateFile from "./components/pages/admin/ValidateRateFile";
import RateFileQuoteResults from "./components/pages/insurance/property/quoting/RateFileQuoteResults";
import ActiveRates from "./components/pages/admin/ActiveRates";
import CustomerPortal from "./components/pages/insurance/property/customer/CustomerPortal";
import CustomerLogin from "./components/pages/insurance/property/customer/CustomerLogin";
import CustomerClaim from "./components/pages/insurance/property/customer/CustomerClaim";
import Cancellation from "./components/pages/insurance/property/customer/Cancellation";
import CustomerClaimTracking from "./components/pages/insurance/property/customer/CustomerClaimTracking";
import CustomerClaimAdmin from "./components/pages/insurance/property/customer/CustomerClaimAdmin";

class Application extends Component {



	render() {
		return (
			<BrowserRouter>
				<Switch>
					<Route path="/" exact render={() => <Redirect to="/quotes" />} />
					<Route path="/results" exact component={Results} />
					<Route path="/confirm" exact component={QuotingConfirm} />

					<Route path="/renew/email/:tokenRenew" component={RenewalsForm} />
					<Route path="/renew/:policyNumber" exact component={RenewalsForm} />
					<Route
						path="/renew/confirm/:policyNumber"
						component={RenewalsConfirm}
					/>

					<Route
						path="/mta/amendpolicy/:policyNumber"
						exact
						render={(props) => <MtaForm modeUpdatingPolicy {...props} />}
					/>
					<Route
						path="/mta/amendquote/:quoteId"
						exact
						render={(props) => <MtaForm modeUpdatingQuote {...props} />}
					/>

					<Route
						path="/mta/confirm/policy/:policyNumber"
						component={MtaConfirm}
					/>
					<Route path="/mta/confirm/quote/:quoteId" component={MtaConfirm} />

					<Route path="/cancellation/:policyNumber" component={Cancellation} />

					<Route path="/thank-you" exact component={ThankYou} />

					<Route path="/portal/:token" exact component={CustomerPortal} />
					<Route path="/customer-login" exact component={CustomerLogin} />
					<Route path="/claim" exact component={CustomerClaim} />
					<Route path="/customer-claim" exact component={CustomerClaimAdmin} />
					<Route path="/track-claim" exact component={CustomerClaimTracking} />

					<PrivateRoute path="/quotes" exact component={Quotes} />
					<PrivateRoute path="/policies" exact component={Policies} />
					<PrivateRoute path="/renewals" exact component={Renewals} />
					<PrivateRoute path="/claims" exact component={Claims} />
					<PrivateRoute path="/reports" exact component={Reports} />
					<PrivateRoute path="/admin" exact component={Admin} />
					<Route path="/login" exact component={Login} />

					<PrivateRoute path="/claims/:claimId" component={EditClaim} />

					<PrivateRoute path="/rates" exact component={Rates} />
					<PrivateRoute path="/rates/active" component={ActiveRates} />
					<PrivateRoute
						path="/rates/:fileName"
						exact
						component={ValidateRateFile}
					/>
					<PrivateRoute
						path="/rates/:fileName/validation-results"
						component={RateFileQuoteResults}
					/>
				</Switch>
			</BrowserRouter>
		);
	}
}

export default Application;
